
import { Component, Prop, Vue } from "nuxt-property-decorator";
import {
  getFormattedPercentage,
  returnPriceFormatDE,
} from "~/mixins/formatting";
import { isPriceInvalid } from "~/utils/priceUtils";

@Component({})
export default class HistoricalPriceDisplay extends Vue {
  @Prop() label: string;
  @Prop({
    type: Object,
    required: true,
  })
  priceData: {
    name: string;
    currentPrice: { value: number; changedAtUnix: number };
    lastPrice: { value: number; changedAtUnix: number };
    relativeChange: number;
  };

  get formattedLastPrice(): string {
    return isPriceInvalid(this.priceData.lastPrice.value)
      ? "--,-- €"
      : returnPriceFormatDE(this.priceData.lastPrice.value);
  }

  get formattedPercentageChange(): string {
    return isPriceInvalid(this.priceData.currentPrice.value) ||
      isPriceInvalid(this.priceData.lastPrice.value)
      ? "--,-- %"
      : getFormattedPercentage(
          this.priceData.currentPrice.value,
          this.priceData.lastPrice.value,
        ).toString();
  }

  returnTrendDirectionString(trendValue: number) {
    const NumberTrendValue = Number(trendValue);
    if (NumberTrendValue === 0) return "right";
    if (NumberTrendValue < 0) return "sinking";
    if (NumberTrendValue > 0) return "rising";
    return "unknown";
  }
}
